import { lazy } from "react";

export const DEFAULTS = {
  subquestId: "1-1",
  levelKey: "L1",
};

// Webpack lazy context for everything in pages/Quests
const ctx = require.context(
  "../pages/Quests",
  true,
  /\.jsx$/,
  "lazy"
);

function lazyFromCtx(
  primaryKey,
  fallbackKey
) {
  return lazy(() =>
    ctx(primaryKey).catch(() =>
      ctx(fallbackKey)
    )
  );
}

function key(q, s, l, file) {
  return `./Quest${q}/Subquest${s}/Level${l}/${file}.jsx`;
}

function mkLevelImports(q, s, l) {
  const fbQ = 1;
  const fbS = 1;
  const fbL = 1;

  return {
    Welcome: lazyFromCtx(
      key(q, s, l, "Welcome1"),
      key(fbQ, fbS, fbL, "Welcome1")
    ),

    Introduction: lazyFromCtx(
      key(q, s, l, "Introduction1"),
      key(
        fbQ,
        fbS,
        fbL,
        "Introduction1"
      )
    ),

    KC1: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConcepts/KeyConcept1"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConcepts/KeyConcept1"
      )
    ),

    KC2: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConcepts/KeyConcept2"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConcepts/KeyConcept2"
      )
    ),

    KC3: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConcepts/KeyConcept3"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConcepts/KeyConcept3"
      )
    ),

    Concept1Example1: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept1Example1"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept1Example1"
      )
    ),

    Concept1Example2: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept1Example2"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept1Example2"
      )
    ),

    Concept1Example3: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept1Example3"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept1Example3"
      )
    ),

    Concept2Example1: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept2Example1"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept2Example1"
      )
    ),

    Concept2Example2: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept2Example2"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept2Example2"
      )
    ),

    Concept2Example3: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept2Example3"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept2Example3"
      )
    ),

    Concept3Example1: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept3Example1"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept3Example1"
      )
    ),

    Concept3Example2: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept3Example2"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept3Example2"
      )
    ),

    Concept3Example3: lazyFromCtx(
      key(
        q,
        s,
        l,
        "KeyConceptExamples/Concept3Example3"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyConceptExamples/Concept3Example3"
      )
    ),

    Summary: lazyFromCtx(
      key(q, s, l, "Summary"),
      key(
        fbQ,
        fbS,
        fbL,
        "KeyTakeAway"
      )
    ),

    Practical: lazyFromCtx(
      key(q, s, l, "Practical"),
      key(
        fbQ,
        fbS,
        fbL,
        "Practical"
      )
    ),

    Result: lazyFromCtx(
      key(q, s, l, "Result"),
      key(
        fbQ,
        fbS,
        fbL,
        "Result"
      )
    ),

    ScenarioQuiz1: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuiz1"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuiz1"
      )
    ),

    ScenarioQuiz2: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuiz2"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuiz2"
      )
    ),

    ScenarioQuiz3: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuiz3"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuiz3"
      )
    ),

    ScenarioQuiz4: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuiz4"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuiz4"
      )
    ),

    ScenarioQuiz5: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuiz5"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuiz5"
      )
    ),

    ScenarioQuiz6: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuiz6"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuiz6"
      )
    ),

    ScenarioDrag1: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuizDrag1"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuizDrag1"
      )
    ),

    ScenarioDrag2: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuizDrag2"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuizDrag2"
      )
    ),

    ScenarioDrag3: lazyFromCtx(
      key(
        q,
        s,
        l,
        "ScenarioQuestions/ScenarioQuizDrag3"
      ),
      key(
        fbQ,
        fbS,
        fbL,
        "ScenarioQuestions/ScenarioQuizDrag3"
      )
    ),
  };
}

function mkFlow(q, s, l) {
  const C = mkLevelImports(q, s, l);

  return [
    {
      path: "welcome",
      Component: C.Welcome,
    },

    {
      path: "introduction",
      Component: C.Introduction,
    },

    {
      path: "concept-1",
      Component: C.KC1,
    },

    {
      path: "concept-1-example-1",
      Component: C.Concept1Example1,
    },

    {
      path: "scenario-quiz-1",
      Component: C.ScenarioQuiz1,
    },

    {
      path: "concept-1-example-2",
      Component: C.Concept1Example2,
    },

    {
      path: "scenario-drag-1",
      Component: C.ScenarioDrag1,
    },

    {
      path: "concept-1-example-3",
      Component: C.Concept1Example3,
    },

    {
      path: "scenario-quiz-2",
      Component: C.ScenarioQuiz2,
    },

    {
      path: "concept-2",
      Component: C.KC2,
    },

    {
      path: "concept-2-example-1",
      Component: C.Concept2Example1,
    },

    {
      path: "scenario-quiz-3",
      Component: C.ScenarioQuiz3,
    },

    {
      path: "concept-2-example-2",
      Component: C.Concept2Example2,
    },

    {
      path: "scenario-drag-2",
      Component: C.ScenarioDrag2,
    },

    {
      path: "concept-2-example-3",
      Component: C.Concept2Example3,
    },

    {
      path: "scenario-quiz-4",
      Component: C.ScenarioQuiz4,
    },

    {
      path: "concept-3",
      Component: C.KC3,
    },

    {
      path: "concept-3-example-1",
      Component: C.Concept3Example1,
    },

    {
      path: "scenario-quiz-5",
      Component: C.ScenarioQuiz5,
    },

    {
      path: "concept-3-example-2",
      Component: C.Concept3Example2,
    },

    {
      path: "scenario-drag-3",
      Component: C.ScenarioDrag3,
    },

    {
      path: "concept-3-example-3",
      Component: C.Concept3Example3,
    },

    {
      path: "scenario-quiz-6",
      Component: C.ScenarioQuiz6,
    },

    {
      path: "summary",
      Component: C.Summary,
    },

    {
      path: "result",
      Component: C.Result,
    },

    {
      path: "practical",
      Component: C.Practical,
    },
  ];
}

export const FLOW_REGISTRY = {};

const STRUCTURE = {
  1: [1, 2, 3],
  2: [1, 2, 3],
  3: [1, 2, 3, 4],
};

for (
  const q of Object.keys(
    STRUCTURE
  ).map(Number)
) {
  for (const s of STRUCTURE[q]) {
    const subId = `${q}-${s}`;

    FLOW_REGISTRY[subId] = {
      L1: mkFlow(q, s, 1),
      L2: mkFlow(q, s, 2),
      L3: mkFlow(q, s, 3),
    };
  }
}

export function playUrl(segment) {
  const quest =
    localStorage.getItem(
      "selectedQuestId"
    ) || "1";

  const sub =
    localStorage.getItem(
      "selectedSubquestId"
    ) || DEFAULTS.subquestId;

  const level =
    localStorage.getItem(
      "selectedLevelKey"
    ) || DEFAULTS.levelKey;

  const seg = String(
    segment || ""
  ).replace(/^\//, "");

  return `/play/${quest}/${sub}/${level}/${seg}`;
}